import { render, staticRenderFns } from "./NewPwdLessPassword.vue?vue&type=template&id=a2479000&scoped=true"
import script from "./NewPwdLessPassword.vue?vue&type=script&lang=js"
export * from "./NewPwdLessPassword.vue?vue&type=script&lang=js"
import style0 from "./NewPwdLessPassword.vue?vue&type=style&index=0&id=a2479000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2479000",
  null
  
)

export default component.exports